import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProjectCard } from '../components/ProjectCard';
import { ArtGallery } from '../components/ArtGallery';
import { Link } from 'react-router-dom';
const projects = [{
  title: 'Payments Re-Imagined',
  badges: ['UX Design', 'Innovation', 'Strategy'],
  description: 'Imagining an innovative & centralized way for financial and corporate treasury clients to manage their payments and liquidity',
  image: 'https://images.unsplash.com/photo-1626379953822-baec19c3accd?auto=format&fit=crop&q=80&w=2070&h=1200',
  role: 'Product Designer',
  duration: 'January 2024 - Present',
  tools: 'Figma, Magic Patterns, Google Gemini',
  industry: 'Financial Services',
  href: '#'
}, {
  title: 'From Chaos to Clarity',
  badges: ['Data Visualization', 'UX Design'],
  description: 'Crafting a Streamlined Dashboard for Intelligent Treasury Operations',
  image: 'https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?q=80&w=2946&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  role: 'Studio Designer',
  duration: '4 Months',
  tools: 'Figma, Power BI,',
  industry: 'Financial Services',
  href: '/dashboard'
}, {
  title: 'Verizon Enterprise Sales Platform',
  badges: ['UX Design', 'Research'],
  description: 'Imagining an innovative & robust sales tool for incredible bulkvolume quote-building and catalog management',
  image: 'https://i.imgur.com/lUcIAKw.jpeg',
  role: 'UX Designer',
  duration: '3 Months',
  tools: 'Figma, Full Story, After Effects',
  industry: 'Telecom',
  href: '/verizon'
}];
function Footer() {
  return <footer className="py-12 text-center text-gray-600 text-sm border-t border-white/10" data-id="element-512">
      <p data-id="element-513">© {new Date().getFullYear()} Taylor Sams. All rights reserved.</p>
      <div className="mt-4" data-id="element-514">
        <Link to="/aboutme" className="text-gray-500 hover:text-white transition-colors" data-id="element-515">
          About Me
        </Link>
      </div>
    </footer>;
}
export function HomePage() {
  return <div className="min-h-screen bg-black text-white selection:bg-white selection:text-black" data-id="element-516">
      <Navbar brand="Taylor Sams" links={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Work',
      href: '#work'
    }, {
      label: 'About',
      href: '/aboutme'
    }]} contactEmail="taylorjsams@gmail.com" data-id="element-517" />

      <main data-id="element-518">
        <Hero data-id="element-519" />

        {/* Work Section */}
        <section id="work" className="py-32 px-6" data-id="element-520">
          <div className="max-w-7xl mx-auto space-y-32" data-id="element-521">
            <div className="mb-24 relative" data-id="element-522">
              {/* Heading */}
              <div className="max-w-7xl mx-auto mb-16" data-id="element-523">
                <h2 className="text-4xl md:text-6xl font-light uppercase tracking-[0.3em] text-white mb-6" data-id="element-524">
                  Selected Work
                </h2>
                <p className="font-mono text-sm text-gray-400 max-w-2xl leading-relaxed" data-id="element-525">
                  A collection of projects that push the boundaries of digital
                  interaction and visual design.
                </p>
              </div>
            </div>
            <div className="space-y-24" data-id="element-526">
              {projects.map((project, index) => <ProjectCard key={index} index={index} {...project} data-id="element-527" />)}
            </div>
          </div>
        </section>

        {/* Art Gallery Section */}
        <div id="studio" data-id="element-528">
          <ArtGallery data-id="element-529" />
        </div>

        {/* Contact Section */}
        <section id="contact" className="py-32 px-6 relative overflow-hidden" data-id="element-530">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/30 pointer-events-none" data-id="element-531" />
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-532">
            <h2 className="text-4xl md:text-6xl font-light uppercase tracking-[0.3em] mb-8 text-white" data-id="element-533">
              Let's Create
            </h2>
            <p className="text-2xl text-gray-400 mb-12 font-light" data-id="element-534">
              Ready to start your next project?
            </p>
            <button className="px-12 py-6 bg-white text-black rounded-full text-xl font-bold hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(255,255,255,0.3)]" data-id="element-535">
              Get in Touch
            </button>
          </div>
        </section>
      </main>

      <Footer data-id="element-536" />
    </div>;
}